export const calculateIncrease = (levelReach?: number | null, seedReach?: number | null) => {
  if (!levelReach || !seedReach) {
    return null;
  }

  const result = levelReach / seedReach;
  const isRound = result % 1 === 0;

  return Number(result).toFixed(isRound ? 0 : 2);
};
